module.exports = __webpack_public_path__ + "static/media/wide.36b76e29.jpg";